import { DEFAULT_VALUE } from '~/constants/transfer'
import { CRYPTO_FORM_CRITERIA } from '~/validate/constant/crypto-form'

type TValidateMessage = Record<string, string>

export const VALIDATION_ERROR_WITHDRAW_MESSAGE: TValidateMessage = {
  REQUIRED_AMOUNT: 'Vui lòng nhập số tiền muốn rút',
  INVALID_BALANCE: 'Số dư không đủ để tạo lệnh rút',
  REQUIRED_WALLET_ADDRESS: 'Vui lòng nhập địa chỉ ví USDT (TRC20)',
  INVALID_CHARACTER_CRYPTO_WALLET_ADDRESS: 'Địa chỉ ví không hợp lệ',
  INVALID_LENGTH_CRYPTO_WALLET_ADDRESS: `Vui lòng nhập từ ${CRYPTO_FORM_CRITERIA.WALLET_ADDRESS_MIN_LENGTH} tới ${CRYPTO_FORM_CRITERIA.WALLET_ADDRESS_MAX_LENGTH} ký tự.`
}

export const VALIDATION_ERROR_TRANSFER_MESSAGE: TValidateMessage = {
  REQUIRED_AMOUNT: 'Vui lòng nhập số tiền chuyển.',
  MIN_MAX_AMOUNT: `Tối thiểu ${DEFAULT_VALUE.MIN} K - Tối đa ${DEFAULT_VALUE.MAX.toLocaleString('en-US')} K`,
  MAX_AMOUNT_TRANSFER: 'Vượt quá số dư khả dụng'
}
